import React, { useEffect, useState, useRef } from "react";

import {
  Layout,
  Card,
  Button,
  Table,
  Tag,
  Avatar,
  Rate,
  Timeline,
  Descriptions,
  Dropdown,
  Menu,
  Row,
  Col,
  Modal,
  Collapse,
  Select,
  Skeleton,
  Slider,
  Checkbox,
} from "antd";
import { PrinterOutlined, HeatMapOutlined } from "@ant-design/icons";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import io from "socket.io-client";

import leftarrow from "../../../../assets/img/orders/leftarrow.png";
import customer from "../../../../assets/img/orders/orderDetail/customer.png";
import mapIcon from "../../../../assets/img/orders/orderDetail/map.png";

import phone from "../../../../assets/img/orders/orderDetail/phone.png";
import message from "../../../../assets/img/orders/orderDetail/message.png";
import orderImg from "../../../../assets/img/orders/orderDetail/order.png";
import priceImg from "../../../../assets/img/orders/orderDetail/price.png";
import user from "../../../../assets/img/orders/orderDetail/user.png";
import whatsappStatus from "../../../../assets/img/orders/orderDetail/whatsappStatus.png";
import minusIcon from "../../../../assets/img/orders/minusIcon.png";
import plusIcon from "../../../../assets/img/orders/plusIcon.png";
import printImg from "../../../../assets/img/orders/orderDetail/print.png";
import QR from "../../../../assets/img/orders/orderDetail/QR.png";
import statuscustomer from "../../../../assets/img/orders/orderDetail/statuscustomer.png";
import storeStatus from "../../../../assets/img/orders/orderDetail/storeStatus.png";
import allStore from "../../../../assets/img/orders/orderDetail/allStore.png";
import prints from "../../../../assets/img/orders/orderDetail/prints.png";

import duration from "../../../../assets/img/orders/orderDetail/duration.png";
import distance from "../../../../assets/img/orders/orderDetail/distance.png";
import vehicle from "../../../../assets/img/orders/orderDetail/vehicle.png";
import like from "../../../../assets/img/orders/orderDetail/like.png";
import fallBackImage from "../../../../assets/img/orders/orderDetail/fallbackimage.png";
import cameraIcon from "../../../../assets/img/orders/orderDetail/cameraIcon.png";
import uploadCameraImage from "../../../../assets/img/orders/orderDetail/uploadIcon.png";
import summary from "../../../../assets/img/orders/orderDetail/like.png";
import { styles } from "components/ImageCropper/styles";

import pickAdd from "../../../../assets/img/orders/orderDetail/pickAdd.png";
import deliveryAdd from "../../../../assets/img/orders/orderDetail/deliveryAdd.png";
import editCollection from "../../../../assets/img/orders/editcollection.png";
import collectionDate from "../../../../assets/img/orders/collectionDate.png";
import deliverytime from "../../../../assets/img/orders/deliverytime.png";
import editdeleivery from "../../../../assets/img/orders/editdeleivery.png";
import jsPDF from "jspdf";

import moment from "moment";
import { API_GET_ORDER } from "api/order-management";
import { useParams } from "react-router-dom";
import { API_ORDER_STATUS } from "api/order-management";
import { API_LIST_LAUNDRY_MEN } from "api/laundry-management";
import { API_ASSIGN_ORDER_TO_DRIVER } from "api/laundry-management";
import { toast } from "react-toastify";
// import Printinvoice from "./Printinvoice";

import { CONSTANTS } from "config/constant";
import Cropper from "react-easy-crop";
import ImageCropper from "components/ImageCropper/ImageCropper";
import { API_REPAIR_ITEM } from "api/order-management";
import DriverMap from "components/Map/DriverMap";
import { API_NEARBY_DRIVER } from "api/order-management";
import userplace from "../../../../assets/img/orders/orderDetail/userplace.png";
import Printinvoice from "../ViewOrder/Printinvoice";
import LaundryBoxOrderTable from "components/Tables/Orders/LaundryBoxOrderTable";

const { Header, Content } = Layout;
const { Panel } = Collapse;

const ViewLaundryBoxOrder = () => {
  // const data = location.state && location.state.data;
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleItems, setIsModalVisibleItems] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [isModalVisibleDriver, setIsModalVisibleDriver] = useState(false);
  const [itemCounts, setItemCounts] = useState({});
  const [triggerUpload, setTriggerUpload] = useState(false);
  const [drivers, setDrivers] = useState();
  const [data, setData] = useState();
  const [status, setStatus] = useState(data?.order_status);
  console.log(status, "statusdadfsa");

  const [activeKeys, setActiveKeys] = useState([]);
  const [image, setImage] = useState(null);
  const [imageToUpload, setImageToUpload] = useState(null);
  const [imagesToSend, setImagesToSend] = useState([]);
  const [displayImage, setDisplayImage] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(
    data?.order_user_info?.phone_no
  );
  const [selectedDriverEmail, setSelectedDriverEmail] = useState(null);
  const [radius, setRadius] = useState(1000); // Default radius value in meters
  const userDataString = localStorage.getItem("userData");
  const Admin = JSON.parse(userDataString);
  const AdminId = Admin?.data?._id;

  const componentRef = useRef();

  let { id } = useParams();

  const [selectedRow, setSelectedRow] = useState(null);
  const handleDriverSelect = (email) => {
    setSelectedDriverEmail(email);
  };

  const showModal = (record) => {
    console.log(record, "recordsdsd");
    setSelectedRow(record);
    setIsModalVisibleItems(true);

    console.log("record in row", record);
  };

  const handleCancel = () => {
    setIsModalVisibleItems(false);
    setSelectedRow(null);
  };

  const handleCollapseChange = (key) => {
    setActiveKeys(key);
  };

  const handleDownload = () => {
    if (data?.qrCode) {
      // Initialize jsPDF instance
      const doc = new jsPDF();

      // Add image to PDF
      doc.addImage(data.qrCode, "PNG", 10, 10, 50, 50); // Adjust positioning and size as needed

      // Save PDF
      doc.save("qrCode.pdf");
    }
  };

  const fetchDataOrder = async () => {
    setLoading(true);
    try {
      const newData = await API_GET_ORDER(id);
      console.log("provider", newData);
      setData(newData?.order);
      setStatus(newData?.order?.order_status);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const options = [
    "order_confirmed",
    "order_accepted",
    "driver_arrived_home_for_pickup",
    "order_pickedup_by_driver",
    "order_delivered_to_store_before_service",
    "order_pickedup_by_driver_to_laundry",
    "order_delivered_to_laundry_before_service",
    "order_service_completed",
    "order_pickedup_by_driver_after_service",
    "order_delivered_to_store_after_service",
    "order_pickedup_by_driver_to_deliver_to_customer",
    "order_delivered_successfully",
  ];
  // const formattedOptions = options?.map((status) => ({
  //   value: status,
  //   label: status
  //     ?.replace(/_/g, " ")
  //     ?.replace(/\b\w/g, (char) => char.toUpperCase()),
  // }));
  const formattedOptions = options?.map((status) => {
    let label = status
      ?.replace(/_/g, " ")
      ?.replace(/\b\w/g, (char) => char.toUpperCase());

    if (status === "order_accepted") {
      label = "Order Accepted by Driver";
    }

    return {
      value: status,
      label: label,
    };
  });

  const orderStatusToggle = async (value) => {
    try {
      const payload = {
        order_id: data?._id,
        order_status: value,
      };
      const userData = await API_ORDER_STATUS(payload);
      setStatus(value);
      toast.success(userData?.message);
    } catch (error) {
      toast.error("Server Error");

      console.error("error", error);
      // toast.error(error?.response?.data?.message);
    } finally {
      // setSubmitting(false);
    }
  };

  const fetchData = async () => {
    try {
      // setLoading(true);
      const payload = {
        order_id: id,
        search_radius: radius,
      };
      // const newData = await API_LIST_LAUNDRY_MEN(params);
      const newData = await API_NEARBY_DRIVER(payload);

      console.log("provider", newData);
      setDrivers(newData?.laundry_men);
      // setLoading(false);
      setPagination({ ...pagination, total: newData.totalLaundryMen }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const handleCountMinus = (item) => {
    setItemCounts((prevItemCounts) => {
      const newCount = (prevItemCounts[item._id] || 1) - 1;
      if (newCount < 1) return prevItemCounts; // Prevent count from going below 1
      return {
        ...prevItemCounts,
        [item._id]: newCount,
      };
    });
  };
  const handleCountPlus = (item) => {
    setItemCounts((prevItemCounts) => ({
      ...prevItemCounts,
      [item._id]: (prevItemCounts[item?._id] || 1) + 1,
    }));
  };
  const handleAssignDriver = async (driver) => {
    // Handle driver assignment logic here
    console.log("Assigned driver:", driver);

    try {
      const payload = {
        laundry_man_id: driver?._id,
        order_id: data?._id,
      };

      const response = await API_ASSIGN_ORDER_TO_DRIVER(payload);
      console.log("response", response);
      if (response) {
        setIsModalVisibleDriver(false);

        toast.success(response?.message);
      }
      fetchDataOrder(); // Refresh data after assigning order
    } catch (error) {
      console.error("Error assigning order to driver:", error);
      // message.error("Failed to assign order to driver");
    }
  };

  // let orderSummary = data?.items
  const calculateTotalPrice = (item) => {
    console.log("item cal", item);
    const total = item?.item_info?.item_service?.reduce(
      (total, service) => total + Number(service?.price),
      0
    );
    const itemCount = itemCounts[item._id] || 1;
    return total * itemCount;
  };
  const columns = [
    { title: "Name", dataIndex: "first_name", key: "first_name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Contact", dataIndex: "phone_no", key: "phone_no" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="primary" onClick={() => handleAssignDriver(record)}>
          Assign
        </Button>
      ),
    },
  ];
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    fetchDataOrder();
  }, [id]);
  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, radius]);

  console.log("data ==>order", data);

  const menu = (
    <Menu>
      <Menu.Item key="1">In Progress</Menu.Item>
      <Menu.Item key="2">Completed</Menu.Item>
      <Menu.Item key="3">Cancelled</Menu.Item>
    </Menu>
  );
  const uniqueServiceIds = [
    ...new Set(
      data?.items?.flatMap((item) =>
        item?.item_info?.item_service?.map((service) => service._id)
      )
    ),
  ];

  const laundryManInfo = data?.order_status_info;
  const lastLaundryManInfo = laundryManInfo
    ? laundryManInfo[laundryManInfo.length - 1]
    : null;

  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setImageToUpload(file);
    console.log(file, "i am");
    const reader = new FileReader();
    reader.onloadend = () => {
      console.log(reader.result, "result");
      setImage(reader?.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
    setTriggerUpload(false);
  };

  const handleUploadImage = async (image) => {
    console.log(image, "image");
    const formData = new FormData();
    formData.append("images", image);
    try {
      const res = await API_REPAIR_ITEM(formData);
      console.log(res);
      setImageModal(false);

      if (res) {
        console.log(";wow", res?.file);
        res?.file?.forEach((element) => {
          setImagesToSend((prev) => [...prev, element]);
        });
        setImageModal(false);
        setImage(null);
        setImageToUpload(null);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (triggerUpload) {
      handleImageClick();
    }
  }, [triggerUpload]);
  console.log(data, "imagessstosend");
  const handleConfirm = () => {
    const data = {
      item_id: "",
      repair: true,
      images: [],
    };
  };

  const convertTimestampsToFormattedDates = (timestamps) => {
    if (
      !timestamps ||
      typeof timestamps !== "object" ||
      !timestamps.from ||
      !timestamps.to
    ) {
      return "Invalid Timestamps";
    }

    const { from, to } = timestamps;
    const fromDate = moment.unix(from);
    const toDate = moment.unix(to);
    if (!fromDate.isValid() || !toDate.isValid()) {
      return "Invalid Date";
    }
    const formattedFrom = fromDate.format("h A ddd, MMM D, YYYY");
    const formattedTo = toDate.format("h A ddd, MMM D, YYYY");
    return `${formattedFrom} - ${formattedTo}`;
  };

  const driversNew = drivers?.map((driver) => ({
    profile: driver?.profile_image[0]?.file_url
      ? CONSTANTS?.IMG_DIRECTORY + driver?.profile_image[0]?.file_url
      : userplace,
    name: `${driver?.first_name} ${driver?.last_name}`,
    email: driver?.email,
    contact: driver?.phone_no,
    latitude: driver?.geo?.coordinates[0],
    longitude: driver?.geo?.coordinates[1],
  }));

  function printImage() {
    const imgSrc = document.getElementById("imageToPrint").src;
    const originalContent = document.body.innerHTML;

    const printContent = `
      <html>
        <head>
          <title>Print Image</title>
          <style>
            body { display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; }
            img { max-width: 100%; max-height: 100%; }
          </style>
        </head>
        <body>
          <img src="${imgSrc}" onload="window.print(); window.onafterprint = () => { document.body.innerHTML = originalContent; }" />
        </body>
      </html>
    `;

    document.body.innerHTML = printContent;
  }
  const rowClassName = (record) => {
    return record.email == selectedDriverEmail ? "selected-rows-driver" : "";
  };
  const rowStyles = (record) => {
    return record.email === selectedDriverEmail
      ? { backgroundColor: "blue !important", color: "white" }
      : {};
  };

  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<---------------------------------Sockets --------------------------------->>>>>>>>>>>>>
  useEffect(() => {
    const socket = io(CONSTANTS?.BACKEND_URL + `?userId=${AdminId}&role=admin`); // Replace with your backend URL

    socket.on("driverUpdate", (updatedDriver) => {
      // setDrivers((prevDrivers) =>
      //   prevDrivers?.map((driver) =>
      //     driver.email === updatedDriver.email ? updatedDriver : driver
      //   )
      // );
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <>
      <Layout>
        <Header className="flex  items-center justify-between bg-white p-4">
          <div className="flex items-center gap-3">
            <div className="flex items-center">
              <img src={leftarrow} />
              <h1 className="font-poppins text-[22px] font-medium text-[#1E293B]">
                Order View
              </h1>
            </div>

            <span className="font-poppins text-[21px] font-medium text-[#3860A4]">
              Order ID: {data?.order_id}
            </span>
          </div>

          <div className="flex items-center">
            <Button
              className="btn-gradient  ml-2 flex w-36 items-center justify-center p-4 text-[white]"
              icon={
                <img src={mapIcon} style={{ height: "1rem", width: "1rem" }} />
              }
              onClick={() => setIsModalVisibleDriver(true)}
            >
              Assign Driver
            </Button>
            <Button
              className="btn-gradient  ml-2 mr-2 flex w-20 items-center justify-center p-5 pb-[12px] pt-[13px] text-[white]"
              icon={<PrinterOutlined />}
              onClick={() => {
                // setSelectedOrder(record);
                // console.log("record", record);
                setTimeout(() => {
                  handlePrint();
                }, 100);
              }}
            >
              Print
            </Button>

            {/* <Dropdown overlay={menu}> */}
            {/* <Button
              className="font-poppins font-medium"
              style={{ border: "none", color: "#9496AE" }}
            >
              Order Status:&nbsp; &nbsp;
              <Tag color="green">{data?.order?.status}</Tag>
            </Button> */}
            <div className="statuss flex items-center gap-2">
              <p>order Status</p>
              <Select
                className="order-status bg-[#EFF2F8]"
                onChange={(value) => {
                  orderStatusToggle(value);
                }}
                value={status}
                style={{ width: "27rem", background: "#EFF2F8" }}
                options={formattedOptions}
              />
            </div>
            <div
              className="ml-3 cursor-pointer"
              onClick={() => setIsModalVisibleDriver(true)}
            ></div>
            {/* </Dropdown> */}
          </div>
        </Header>
        <Content className="bg-white p-6  ">
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={8}>
              {loading ? (
                <>
                  <Skeleton active />
                </>
              ) : (
                <Card style={{ border: "none" }}>
                  <div className="flex justify-between">
                    {" "}
                    <p className="mb-4 font-semibold text-[#8B8B8B]">
                      Cusomer Details
                    </p>
                  </div>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>
                      <div>
                        <div className="mb-3 flex items-center gap-2">
                          <img
                            src={
                              data?.order_user_info?.profile_image?.[0]
                                ?.file_url
                                ? CONSTANTS?.IMG_DIRECTORY +
                                  data?.order_user_info?.profile_image?.[0]
                                    ?.file_url
                                : customer
                            }
                            style={{ maxWidth: "2.5rem", maxHeight: "2rem" }}
                          />

                          <div>
                            <p className="font-poppins font-normal text-[#9496AE]">
                              Customer
                            </p>
                            <p className="font-medium text-[#3860A4]">
                              {data?.order_user_info?.first_name +
                                " " +
                                data?.order_user_info?.last_name}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center justify-between gap-2">
                          <div className="flex items-center gap-2">
                            <img src={orderImg} />
                            <div>
                              <p className="font-poppins font-normal text-[#9496AE]">
                                Order
                              </p>
                              <p className="font-medium text-[#3860A4]">
                                items ({data?.total_items}){" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col span={14}>
                      <div className="flex items-start justify-end gap-12">
                        <div>
                          <div className="mb-3 flex justify-end gap-4">
                            <img
                              src={phone}
                              onClick={() => {
                                setPhoneNumber(data?.order_user_info?.phone_no);
                                setIsModalVisible(true);
                              }}
                            />
                            <img
                              src={message}
                              onClick={() =>
                                window.open(
                                  `https://wa.me/${data?.order_user_info?.phone_no}`,
                                  "_blank"
                                )
                              }
                            />
                          </div>
                          <div className="flex items-center gap-2">
                            <img src={priceImg} />
                            <div>
                              <div className="flex justify-between">
                                <p className="font-poppins font-normal text-[#9496AE]">
                                  Price
                                </p>

                                {/* <p className="font-poppins font-normal text-[#9496AE]">
                              Paid
                            </p> */}
                              </div>
                              <p className="font-medium text-[#3860A4]">
                                {data?.invoice_details?.total_amount.toFixed(2)}{" "}
                                SAR{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2">
                          <img
                            src={data?.qrCode}
                            className="h-24 w-24"
                            id="imageToPrint"
                          />
                          <a
                            // href={data?.qrCode}
                            // download="qrCode.png"
                            onClick={printImage}
                            className="mt-2 flex justify-center"
                          >
                            <img src={prints} />
                          </a>
                        </div>
                      </div>
                      <Modal
                        title="User Phone Number"
                        visible={isModalVisible}
                        onCancel={() => {
                          setIsModalVisible(false);
                        }}
                        footer={null}
                      >
                        <p>{phoneNumber}</p>
                      </Modal>
                    </Col>
                  </Row>
                  <div className="mt-8">
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <div
                          className="relative h-auto cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px]  text-center text-[12px]"
                          style={{
                            border: "1px solid #CEAF89",
                            // paddingBottom: "8px",
                            // paddingTop: "8px",
                          }}
                        >
                          <div className="absolute left-[6px] top-[-6px] rounded-[3.13px] bg-[#FAF7F3] px-1 text-[9px] text-[#F4B718]">
                            {/* <img src={editCollection} /> */}
                            Collection Time & Date
                          </div>
                          <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                            <img src={collectionDate} className="h-4" />
                          </div>
                          <p className="text-center">
                            Collection Time :{" "}
                            {data?.order_pickup_time
                              ? convertTimestampsToFormattedDates(
                                  data?.order_pickup_time
                                )
                              : moment(data?.order_pickup_time?.from).format(
                                  "h A ddd, MMM D, YYYY"
                                )}
                          </p>
                          {/* {moment(data?.order_pickup_time?.from).format(
                          "h A ddd, MMM D, YYYY"
                        )} */}
                        </div>
                      </Col>
                      <Col span={12}>
                        <div
                          className="relative h-auto cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px] text-center text-[12px]"
                          style={{
                            border: "1px solid #1CAB43",
                            // paddingBottom: "8px",
                            // paddingTop: "8px",
                          }}
                        >
                          <div className="absolute left-[6px] top-[-6px]">
                            <img src={deliverytime} />
                          </div>
                          <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                            <img src={editdeleivery} className="h-4" />
                          </div>
                          {/* 9Am -11Am Tue, 2024 */}
                          <p className="text-center">
                            Delivery Time :{" "}
                            {convertTimestampsToFormattedDates(
                              data?.order_delivery_time
                            )}
                            {/* {moment(data?.order_delivery_time?.to).format(
                          "h A ddd, MMM D, YYYY"
                        )} */}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Card>
              )}
              <hr />

              <div className="Time Logs History current-status">
                {loading ? (
                  <Skeleton active />
                ) : (
                  <Card className="time-logs" style={{ border: "none" }}>
                    <Collapse
                      style={{ border: "none" }}
                      expandIconPosition="right" // Set the expand icon position to right
                      className="custom-collapse" // Add a custom class for further styling
                    >
                      <Panel
                        header="Time Logs History"
                        key="1"
                        style={{ border: "none" }}
                      >
                        <Row gutter={[16, 16]}>
                          <Col span={12}>
                            <div
                              className="relative h-[3rem] cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px]  text-[12px]"
                              style={{
                                border: "1px solid #CEAF89",
                              }}
                            >
                              <div className="absolute left-[6px] top-[-6px]">
                                <img
                                  src={editCollection}
                                  alt="Edit Collection"
                                />
                              </div>
                              <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                                <img
                                  src={collectionDate}
                                  className="h-4"
                                  alt="Collection Date"
                                />
                              </div>
                              <p className="text-center">
                                Collection Time :{" "}
                                {moment().format("h A ddd, MMM D, YYYY")}
                              </p>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div
                              className="relative h-[3rem] cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px]  text-[12px]"
                              style={{
                                border: "1px solid #1CAB43",
                              }}
                            >
                              <div className="absolute left-[6px] top-[-6px]">
                                <img src={deliverytime} alt="Delivery Time" />
                              </div>
                              <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                                <img
                                  src={editdeleivery}
                                  className="h-4"
                                  alt="Edit Delivery"
                                />
                              </div>
                              <p className="text-center">
                                Delivery Time :{" "}
                                {moment().format("h A ddd, MMM D, YYYY")}
                              </p>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div
                              className="relative h-[3rem] cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px]  text-[12px]"
                              style={{
                                border: "1px solid #CEAF89",
                              }}
                            >
                              <div className="absolute left-[6px] top-[-6px]">
                                <img
                                  src={editCollection}
                                  alt="Edit Collection"
                                />
                              </div>
                              <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                                <img
                                  src={collectionDate}
                                  className="h-4"
                                  alt="Collection Date"
                                />
                              </div>
                              <p className="text-center">
                                Collection Time :{" "}
                                {moment().format("h A ddd, MMM D, YYYY")}
                              </p>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div
                              className="relative h-[3rem] cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px] text-[12px]"
                              style={{
                                border: "1px solid #1CAB43",
                              }}
                            >
                              <div className="absolute left-[6px] top-[-6px]">
                                <img src={deliverytime} alt="Delivery Time" />
                              </div>
                              <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                                <img
                                  src={editdeleivery}
                                  className="h-4"
                                  alt="Edit Delivery"
                                />
                              </div>
                              <p className="text-center">
                                {" "}
                                Delivery Time :{" "}
                                {moment().format("h A ddd, MMM D, YYYY")}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </Panel>
                    </Collapse>
                  </Card>
                )}
              </div>
              <hr />

              <div className=" current-status  Time Logs History ">
                {loading ? (
                  <Skeleton active />
                ) : (
                  <Card
                    className=" current-status time-logs curssss"
                    style={{ border: "none" }}
                  >
                    <Collapse
                      defaultActiveKey={["1"]}
                      style={{ border: "none" }}
                      expandIconPosition="right" // Set the expand icon position to right
                      className="custom-collapse" // Add a custom class for further styling
                    >
                      <Panel
                        header="current Status"
                        key="1"
                        style={{ border: "none" }}
                      >
                        {lastLaundryManInfo?.laundry_man_info ? (
                          <>
                            <Row gutter={[16, 16]}>
                              <Col span={16}>
                                <>
                                  <p className="mb-4 font-poppins text-[#383838]">
                                    Customer to Store
                                  </p>

                                  {/* <div className="mb-3 flex items-center gap-2">
                            <img src={user} />
                            <div>
                              <p className="font-poppins font-medium text-[#3860A4]">
                                {data?.pickup_laundry_man_info?.first_name ??
                                  "" +
                                    " " +
                                    data?.pickup_laundry_man_info?.last_name ??
                                  ""}
                              </p>
                              {data?.pickup_laundry_man_info && (
                                <p className="font-poppins text-[12px] font-normal text-[#9496AE]">
                                  Order no:{" "}
                                  <span className="text-[12px] font-medium text-[#9496AE]">
                                    {data?.order_id}
                                  </span>
                                </p>
                              )}
                            </div>
                          </div> */}

                                  <div className="mb-3 flex items-center gap-2">
                                    <img
                                      src={
                                        lastLaundryManInfo?.laundry_man_info
                                          ?.profile_image?.[0]?.file_url
                                          ? CONSTANTS?.IMG_DIRECTORY +
                                            lastLaundryManInfo?.laundry_man_info
                                              ?.profile_image?.[0]?.file_url
                                          : user
                                      }
                                      style={{
                                        height: "2rem",
                                        width: "2rem",
                                        borderRadius: "50%",
                                      }}
                                    />
                                    <div>
                                      <p className="font-poppins font-medium text-[#3860A4]">
                                        {(lastLaundryManInfo?.laundry_man_info
                                          ?.first_name
                                          ? lastLaundryManInfo?.laundry_man_info
                                              ?.first_name
                                          : "No Name of driver") +
                                          " " +
                                          (lastLaundryManInfo?.laundry_man_info
                                            ?.last_name
                                            ? lastLaundryManInfo
                                                ?.laundry_man_info?.last_name
                                            : "")}
                                      </p>
                                      {data?.pickup_laundry_man_info && (
                                        <p className="font-poppins text-[12px] font-normal text-[#9496AE]">
                                          Order no:{" "}
                                          <span className="text-[12px] font-medium text-[#9496AE]">
                                            {data?.order_id}
                                          </span>
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </>
                              </Col>
                              <Col span={8}>
                                <img src={allStore} className="mb-4 w-[4rem]" />

                                <div className="flex space-x-4">
                                  <img
                                    src={phone}
                                    onClick={() => {
                                      setPhoneNumber(
                                        lastLaundryManInfo?.laundry_man_info
                                          ?.phone_no
                                      );
                                      setIsModalVisible(true);
                                    }}
                                  />
                                  <img
                                    src={whatsappStatus}
                                    style={{ height: "2.5rem" }}
                                    onClick={() =>
                                      window.open(
                                        `https://wa.me/${lastLaundryManInfo?.laundry_man_info?.phone_no}`,
                                        "_blank"
                                      )
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>

                            {/* <Row gutter={[16, 16]}>
                            <Col span={8}>
                              <div className="flex items-center gap-2">
                                <img
                                  src={duration}
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                    objectFit: "cover",
                                  }}
                                />
                                <div>
                                  <p className="font-poppins text-[11px] font-normal text-[#9496AE]">
                                    Duration
                                  </p>
                                  <p className="font-poppins text-[11px] font-medium text-[#3860A4]">
                                    {" "}
                                    {data?.currentStatus?.duration}
                                  </p>
                                </div>
                              </div>
                            </Col>

                            <Col span={8}>
                              <div className="flex items-center gap-2">
                                <img
                                  src={distance}
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                    objectFit: "cover",
                                  }}
                                />
                                <div>
                                  <p className="font-poppins text-[11px] font-normal text-[#9496AE]">
                                    Distance
                                  </p>
                                  <p className="font-poppins text-[11px] font-medium text-[#3860A4]">
                                    {" "}
                                    {data?.currentStatus?.distance}
                                  </p>
                                </div>
                              </div>
                            </Col>

                            <Col span={8}>
                              <div className="flex items-center gap-2">
                                <img
                                  src={vehicle}
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                    objectFit: "cover",
                                  }}
                                />
                                <div>
                                  <p className="font-poppins text-[11px] font-normal text-[#9496AE]">
                                    Vehicle
                                  </p>
                                  <p className="font-poppins text-[11px] font-medium text-[#3860A4]">
                                    {" "}
                                    {data?.currentStatus?.vehicle}
                                  </p>
                                </div>
                              </div>
                            </Col>
                          </Row> */}
                          </>
                        ) : (
                          <p>No driver Information</p>
                        )}
                      </Panel>
                    </Collapse>
                  </Card>
                )}
              </div>
              <div className=" Reviews Time Logs History current-status">
                {loading ? (
                  <Skeleton active />
                ) : (
                  <Card
                    className=" Reviews time-logs"
                    style={{ border: "none" }}
                  >
                    <Collapse
                      defaultActiveKey={["1"]}
                      style={{ border: "none" }}
                      expandIconPosition="right" // Set the expand icon position to right
                      className="custom-collapse" // Add a custom class for further styling
                    >
                      <Panel
                        header="Reviews"
                        key="1"
                        style={{ border: "none" }}
                      >
                        <Row gutter={[16, 16]}>
                          <Col span={6}>
                            <div className="flex items-center space-x-3">
                              <img src={like} />
                              {data?.order_review?.[0]?.application_review
                                ?.review ? (
                                <div>
                                  <p className="font-poppins text-[12px] font-normal text-[#383838]">
                                    Application
                                  </p>
                                  <Rate
                                    disabled
                                    value={
                                      data?.order_review?.[0]
                                        ?.application_review?.review
                                    }
                                  />
                                </div>
                              ) : (
                                <p className="font-poppins text-[9px] font-normal text-[#383838]">
                                  No Application Review
                                </p>
                              )}
                            </div>
                          </Col>

                          <Col span={6}>
                            <div className="flex items-center space-x-3">
                              <img src={like} />
                              {data?.order_review?.[0]?.pickup_driver_review
                                ?.review ? (
                                <div>
                                  <p className="font-poppins text-[12px] font-normal text-[#383838]">
                                    Quality of service
                                  </p>
                                  <Rate
                                    disabled
                                    value={
                                      data?.order_review?.[0]?.service_review
                                        ?.review
                                    }
                                  />
                                </div>
                              ) : (
                                <p className="font-poppins text-[9px] font-normal text-[#383838]">
                                  No Quality of service Review
                                </p>
                              )}
                            </div>
                          </Col>

                          <Col span={6}>
                            <div className="flex items-center space-x-3">
                              <img src={like} />
                              {data?.order_review?.[0]?.pickup_driver_review
                                ?.review ? (
                                <div>
                                  <p className="font-poppins text-[12px] font-normal text-[#383838]">
                                    Pickup Driver
                                  </p>
                                  <Rate
                                    disabled
                                    value={
                                      data?.order_review?.[0]
                                        ?.pickup_driver_review?.review
                                    }
                                  />
                                </div>
                              ) : (
                                <p className="font-poppins text-[9px] font-normal text-[#383838]">
                                  No pickup Driver Review{" "}
                                </p>
                              )}
                            </div>
                          </Col>

                          <Col span={6}>
                            <div className="flex items-center space-x-3">
                              <img src={like} />
                              {data?.order_review?.[0]?.delivery_driver_review
                                ?.review ? (
                                <div>
                                  <p className="font-poppins text-[12px] font-normal text-[#383838]">
                                    Delivery driver
                                  </p>
                                  <Rate
                                    disabled
                                    value={
                                      data?.order_review?.[0]
                                        ?.delivery_driver_review?.review
                                    }
                                  />
                                </div>
                              ) : (
                                <p className="font-poppins text-[9px] font-normal text-[#383838]">
                                  No Delivery driver Review
                                </p>
                              )}
                            </div>
                          </Col>

                          {/* <Rate disabled defaultValue={data?.reviews.quality} />
                  <Rate disabled defaultValue={data?.reviews.pickupDriver} />
                  <Rate disabled defaultValue={data?.reviews.deliveryDriver} /> */}
                        </Row>
                      </Panel>
                    </Collapse>
                  </Card>
                )}
              </div>
              <hr />

              {(data?.pickup_from_customer_info?.first_name ||
                data?.pickup_from_store_before_service_info?.first_name ||
                data?.pickup_from_store_after_service_info?.first_name) && (
                <div className="Drivers   current-status">
                  <Card title="Drivers" style={{ border: "none" }}>
                    <Row gutter={[16, 16]}>
                      {data?.pickup_from_customer_info?.first_name && (
                        <Col xs={24} lg={6}>
                          <p>
                            <p>Customer to Store</p>
                            <img src={allStore} />
                            <div className="flex items-center justify-between">
                              <p className="font-poppins text-[#46BCED]">
                                {/* John Doe */}
                                {data?.pickup_from_customer_info?.first_name +
                                  " " +
                                  data?.pickup_from_customer_info?.last_name}
                              </p>
                              <img
                                src={phone}
                                className="h-6"
                                onClick={() => {
                                  setPhoneNumber(
                                    data?.pickup_from_customer_info?.phone_no
                                  );
                                  setIsModalVisible(true);
                                }}
                              />
                            </div>
                          </p>
                        </Col>
                      )}

                      {data?.pickup_from_store_before_service_info && (
                        <Col xs={24} lg={6}>
                          <p>
                            <p>Store to Laundry</p>
                            <img src={allStore} />
                            <div className="flex items-center justify-between">
                              <p className="font-poppins text-[#46BCED]">
                                {/* John Doe */}
                                {data?.pickup_from_store_before_service_info
                                  ?.first_name +
                                  " " +
                                  data?.pickup_from_store_before_service_info
                                    ?.last_name}
                              </p>
                              <img
                                src={phone}
                                className="h-6"
                                onClick={() => {
                                  setPhoneNumber(
                                    data?.pickup_from_store_before_service_info
                                      ?.phone_no
                                  );
                                  setIsModalVisible(true);
                                }}
                              />
                            </div>
                          </p>
                        </Col>
                      )}
                      {data?.pickup_from_store_after_service_info && (
                        <Col xs={24} lg={6}>
                          <p>
                            <p>Laundry to Store</p>
                            <img src={allStore} />
                            <div className="flex items-center justify-between">
                              <p className="font-poppins text-[#46BCED]">
                                {/* John Doe */}
                                {data?.pickup_from_store_after_service_info
                                  ?.first_name +
                                  " " +
                                  data?.pickup_from_store_after_service_info
                                    ?.last_name}
                              </p>
                              <img
                                src={phone}
                                className="h-6"
                                onClick={() => {
                                  setPhoneNumber(
                                    data?.pickup_from_store_after_service_info
                                      ?.phone_no
                                  );
                                  setIsModalVisible(true);
                                }}
                              />
                            </div>
                          </p>
                        </Col>
                      )}

                      {data?.pickup_from_store_after_service_info
                        ?.first_name && (
                        <Col xs={24} lg={6}>
                          <p>
                            <p>Store to Customer</p>
                            <img src={allStore} />
                            <div className="flex items-center justify-between">
                              <p className="font-poppins text-[#46BCED]">
                                {/* John Doe */}
                                {data?.pickup_from_store_after_service_info
                                  ?.first_name +
                                  " " +
                                  data?.pickup_from_store_after_service_info
                                    ?.last_name}
                              </p>
                              <img
                                src={phone}
                                className="h-6"
                                onClick={() => {
                                  setPhoneNumber(
                                    data?.pickup_from_store_after_service_info
                                      ?.phone_no
                                  );
                                  setIsModalVisible(true);
                                }}
                              />
                            </div>
                          </p>
                        </Col>
                      )}
                    </Row>
                  </Card>
                </div>
              )}
            </Col>

            <Col xs={24} lg={16}>
              <div className="">
                {/* <img src={summary} className="absolute" /> */}
                {loading ? (
                  <>
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                  </>
                ) : (
                  <Card title="Order Summary" className="new-ss">
                    <Row gutter={[16, 16]}>
                      {data?.items_grouped_by_services?.map((item, index) => {
                        console.log(item, "itemssss");
                        // Filter items by service ID
                        // const filteredItems = data?.items?.filter(
                        //   (item) =>
                        //     item?.item_info?.item_service?.[0]?._id === serviceId
                        // );

                        // Filter items by service ID
                        // const filteredItems = data?.items?.filter((item) =>
                        //   item?.item_info?.item_service?.some(
                        //     (service) => service?._id === serviceId
                        //   )
                        // );
                        // console.log("filteredItems");

                        // const serviceName =
                        //   filteredItems?.[0]?.item_info?.item_service?.find(
                        //     (service) => service._id === serviceId
                        //   )?.service_name;

                        return (
                          <Col xs={24} lg={12} key={item?._id}>
                            <Collapse
                              defaultActiveKey={["1"]} // Set the default active key
                              style={{ border: "none" }}
                              expandIconPosition="right" // Set the expand icon position to right
                              className="custom-collapsess" // Add a custom class for further styling
                            >
                              <Panel
                                header={item?.service_name}
                                key="1"
                                style={{
                                  border: "none",
                                  background: "#3860A4",
                                  color: "white",
                                  borderRadius: "14px",
                                }}
                              >
                                <Card
                                  type="inner"
                                  className="summary-table"
                                  style={{ border: "none" }}
                                >
                                  <Table
                                    dataSource={item?.items}
                                    columns={[
                                      {
                                        title: "Item",
                                        dataIndex: ["item_info", "item_name"],
                                        key: "item_info.item_name",
                                        render: (text, record) => (
                                          <span>{record?.item_name}</span>
                                        ),
                                      },
                                      {
                                        title: "Quantity",
                                        dataIndex: "item_info.total_quantity",
                                        key: "item_info.total_quantity",
                                        render: (text, record) => (
                                          <span>
                                            {record?.quantity + " " + "Items"}
                                          </span>
                                        ),
                                      },
                                      {
                                        title: "Price",
                                        dataIndex: "price",
                                        key: "price",
                                        render: (text, record) => (
                                          <span>
                                            {record?.price * record?.quantity +
                                              " " +
                                              "SAR"}
                                          </span>
                                        ),
                                      },
                                    ]}
                                    // onRow={(record) => ({
                                    //   onClick: () => showModal(record),
                                    // })}
                                    pagination={false}
                                    style={{
                                      border: "none",
                                      padding: "0",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Card>
                              </Panel>
                            </Collapse>
                          </Col>
                        );
                      })}
                    </Row>
                  </Card>
                )}
                <div className="current-status">
                  <Card>
                    <div className="mb-4">
                      <hr className="mb-4" />

                      <div className="flex justify-between">
                        <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                          Order Type
                        </span>
                        <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                          {data?.order_type}
                        </span>
                      </div>

                      <div className="flex justify-between">
                        <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                          Tax
                        </span>
                        <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                          {data?.invoice_details?.tax ?? 0} SAR
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                          Total Items
                        </span>
                        <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                          {data?.total_items} Items
                        </span>
                      </div>

                      <div className="flex justify-between">
                        <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                          Delivery Fees
                        </span>
                        <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                          {data?.invoice_details?.delivery_fee ?? 0} SAR
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                          Discount
                        </span>
                        <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                          {data?.invoice_details?.discount ?? 0} SAR
                        </span>
                      </div>

                      <div className="flex justify-between">
                        <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                          Total
                        </span>
                        <span className="font-poppins text-[15px] font-semibold text-[#FF0000]">
                          {data?.invoice_details?.total_amount ?? 0} SAR
                        </span>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </Col>
          </Row>

          {selectedRow && (
            <Modal
              visible={isModalVisibleItems}
              onCancel={handleCancel}
              closeIcon={false}
              style={{ minWidth: "674px" }}
              className="item-modal"
            >
              <div className="flex flex-row items-center justify-between px-[26px] pb-[9px]">
                <h1 className="text-[20px] font-medium leading-[28px] text-[#3860A4]">
                  {selectedRow?.item_info?.item_name}
                </h1>
                <h1 className="text-[20px] font-medium leading-[28px] text-[#3860A4]">
                  Wash + Iron
                </h1>
              </div>
              <div className="item-modal border-y-[1px] px-[26px] py-[18px]">
                {/* <Col span={12}>
                  <img src={selectedRow?.item_info?.image} alt="Item" />
                </Col> */}

                <Col>
                  <div className="flex flex-row items-start justify-between">
                    <Card className="side-card w-[299px] cursor-pointer rounded-lg border px-[14px] py-[14px] shadow-lg">
                      <div className="flex items-center justify-between pr-2">
                        <div className="flex flex-row items-center gap-[12px]">
                          <img
                            src={
                              displayImage
                                ? displayImage
                                : selectedRow?.item?.images?.[0]?.file_url
                                ? CONSTANTS?.IMG_DIRECTORY +
                                  selectedRow?.item?.images?.[0]?.file_url
                                : fallBackImage
                            }
                            alt="Item"
                            className="h-14 w-14 rounded-2xl"
                          />

                          <div className="flex flex-col gap-[15px] ">
                            <p className="text-[#46BCED]">
                              {selectedRow?.item_info?.item_name}
                            </p>
                            <div className="flex h-[28px] w-[73px] flex-row items-center justify-between rounded-[100px] bg-[#172e5512]  px-[6px]">
                              <div
                                onClick={() => handleCountMinus(selectedRow)}
                                className="flex h-[16px] w-[16px] flex-row content-center items-center justify-center rounded-full border-[1px] border-[#9496AE80] text-[#9496AE80]"
                              >
                                -
                              </div>
                              <p className="text-600 text-[#3860A4]">
                                {/* {itemsCount} */}
                                {itemCounts[selectedRow?._id] || 1}
                              </p>{" "}
                              <div
                                onClick={() => {
                                  handleCountPlus(selectedRow);
                                }}
                                className="flex h-[16px] w-[16px] items-center justify-center rounded-full bg-[#46BCED] text-center text-white"
                              >
                                +
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <h3 className=" font-poppins text-[15px] font-normal text-[#3860A4]">
                            {selectedRow?.tem_info?.item_name}
                          </h3>
                        </div>
                        <div>
                          <span className="font-poppins font-semibold text-[#3860A4]">
                            SAR{calculateTotalPrice(selectedRow)}
                          </span>
                        </div>
                      </div>
                      <div className="mt-[20px] flex flex-row items-center justify-between">
                        <div className="flex flex-row items-start ">
                          <div onClick={() => setImageModal(true)}>
                            <img src={cameraIcon} alt="" />
                          </div>
                          {imagesToSend?.length > 0 ? (
                            <div className="scroll-behaviour flex w-[145px] flex-row items-center space-x-1 overflow-scroll overflow-y-hidden">
                              {imagesToSend?.map((element, idx) => {
                                return (
                                  <div
                                    key={idx}
                                    className="h-[25px] w-[25px]"
                                    onClick={() =>
                                      setDisplayImage(
                                        CONSTANTS?.IMG_DIRECTORY +
                                          element?.file_url
                                      )
                                    }
                                  >
                                    <img
                                      src={
                                        CONSTANTS?.IMG_DIRECTORY +
                                        element?.file_url
                                      }
                                      alt=""
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          ) : null}
                        </div>

                        <div>
                          {" "}
                          <Checkbox className="text-gray-400 ">
                            Repairing
                          </Checkbox>
                        </div>
                      </div>
                    </Card>
                  </div>
                </Col>
              </div>
              <div className="flex h-full  flex-row items-center justify-center pb-[23px] pt-[17px] ">
                <button className="h-[43px] w-[204px] rounded-[9.6px] bg-[#7E80FE] text-center text-white">
                  Confirm
                </button>
              </div>

              <Modal
                visible={imageModal}
                onCancel={() => setImageModal(false)}
                closeIcon={false}
                className="image-upload"
              >
                {image ? (
                  <div className="flex flex-col items-center justify-between gap-[21px]">
                    <div className="flex h-[208px] w-[426px]  items-center justify-center overflow-hidden">
                      <img src={image} alt="" />{" "}
                    </div>
                    <div className="flex flex-row items-center gap-[18.36px]">
                      <button
                        onClick={() => {
                          if (image) {
                            setImage(null);
                            setTriggerUpload(true);
                          }
                        }}
                        className="flex h-[48.14px] w-[162px] items-center justify-center rounded-[3.78px] text-center text-[#3860A4] shadow-xl"
                      >
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleImageUpload}
                        />
                        Redo
                      </button>
                      <button
                        className="flex h-[48.14px] w-[162px] items-center justify-center rounded-[3.78px] bg-[#7E80FE] text-center text-white shadow-xl"
                        onClick={() => handleUploadImage(imageToUpload)}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    onClick={() => {
                      setImageModal(true);
                      handleImageClick();
                    }}
                    className="flex flex-col items-center justify-center"
                  >
                    <img src={uploadCameraImage} alt="" />
                    <h1 className="text-[17.88px] font-normal text-[#3860A4]">
                      Upload Image{" "}
                    </h1>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleImageUpload}
                    />
                  </div>
                )}
              </Modal>
            </Modal>
          )}
        </Content>
        <Modal
          title="Select Driver"
          className="order-driver-modal driver-mod"
          visible={isModalVisibleDriver}
          onCancel={() => setIsModalVisibleDriver(false)}
          footer={null}
          centered
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Table
                columns={columns}
                dataSource={drivers}
                rowKey="email"
                style={{ width: "100%" }}
                rowClassName={rowClassName}
                rowStyle={rowStyles}

                // pagination={{ pageSize: 5 }}
              />
            </Col>
            <Col span={12}>
              <div style={{ height: "400px" }}>
                {" "}
                {/* Ensure the container has a defined height */}
                <DriverMap
                  drivers={driversNew}
                  onDriverSelect={handleDriverSelect}
                  radius={radius}
                  orderData={data}
                />
              </div>
              <Slider
                min={500}
                max={5000}
                step={100}
                value={radius}
                onChange={(value) => setRadius(value)}
                // tooltipVisible
              />
            </Col>
          </Row>
        </Modal>
        <div style={{ display: "none" }}>
          <div
            className="flex flex-col items-center justify-center rounded-lg bg-white p-4 shadow-md "
            ref={componentRef}
          >
            <Printinvoice data={data} />
          </div>
        </div>
      </Layout>
      <LaundryBoxOrderTable />
    </>
  );
};

export default ViewLaundryBoxOrder;
